const PlayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
    >
      <path
        d="M16.6836 22.0017V19.2884C16.6836 15.7867 19.1586 14.375 22.1836 16.1167L24.5303 17.4734L26.8769 18.83C29.9019 20.5717 29.9019 23.4317 26.8769 25.1734L24.5303 26.53L22.1836 27.8867C19.1586 29.6284 16.6836 28.1984 16.6836 24.715V22.0017Z"
        fill="white"
        stroke="white"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.9996 40.3346C32.1248 40.3346 40.3329 32.1265 40.3329 22.0013C40.3329 11.8761 32.1248 3.66797 21.9996 3.66797C11.8744 3.66797 3.66626 11.8761 3.66626 22.0013C3.66626 32.1265 11.8744 40.3346 21.9996 40.3346Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default PlayIcon;
